import React from 'react';
import { answerDecoder } from '../form_tools/answerEncoderDecoder';
import { dynamicRender, hasMeaningfulOptions } from '../form_tools/dynamicRender';
import { parseJson } from '../form_tools/extraFunction';

const CALENDAR_ANSWER = 'calendar_answer';
const TABLE_ANSWER = 'table_answer';
const REPEATABLE_SECTION_ANSWER = 'repeatable_sections_answer';

class FormDataManager {
  constructor(formComponent) {
    this.form = formComponent;
  }

  /**
   * Processes and dispatches data from form components
   */
  getDataFromComponent = (
    data,
    key,
    question_text,
    answer_list,
    outputFormat,
    timezone,
    tableAnswerKeys,
    exportFormat
  ) => {
    let format = Object.keys(data)[0];

    data = answerDecoder(data, answer_list);

    if (format == CALENDAR_ANSWER) {
      if (!data[0]) return;
      const date = new Date(data[0]);
      const isoString = date.toISOString();
      this.form.props.dispatchaddPageDataCalendar(
        key,
        data,
        question_text,
        format,
        isoString,
        outputFormat,
        timezone
      );
    } else if (
      format === TABLE_ANSWER ||
      format === REPEATABLE_SECTION_ANSWER
    ) {
      const colNames = answer_list
        ? answer_list.map((item) => {
            return item.columnName;
          })
        : [];

      this.form.props.dispatchaddPageDataTable(
        key,
        data,
        question_text,
        format,
        exportFormat,
        tableAnswerKeys,
        colNames
      );
    } else
      this.form.props.dispatchaddPageData(key, data, question_text, format);
  };

  /**
   * Handles page loading and answer processing
   */
  handlePageLoad = async () => {
    let { form } = this.form.props;
    let page_data = form.request_data[form.current_index];
    let answer_list = '';

    let page_answer = {};
    const pageComponents = page_data.components || page_data.fields || [];
    Object.keys(this.form.state.answer).map((key) => {
      for (let i in pageComponents) {
        if (key == pageComponents[i].key) {
          const comp = pageComponents[i];
          const isV2 = comp.type && !comp.views;
          const hasItems = (value) => Array.isArray(value) && value.length > 0;
          const legacyAnswerData = comp.views?.answer?.view?.data;
          const getLegacyAnswerList = () =>
            legacyAnswerData
              ? parseJson(
                  dynamicRender(
                    this.form,
                    legacyAnswerData.default,
                    legacyAnswerData.dynamic
                  )
                )
              : '';
          if (isV2) {
            const fieldType = comp.type;
            if (fieldType === 'table' || fieldType === 'repeatable_section') {
              answer_list = (comp.columns || comp.fields || []).map(c => ({
                ...c,
                columnName: c.columnName || c.label || '',
                id: c.id || c.key || '',
                question: c.question || c.label || '',
              }));
            } else {
              answer_list = comp.options || '';
            }
          } else {
            const fieldType = comp.type || comp.views?.answer?.view?.format;
            if (fieldType === 'table' || fieldType === 'repeatable_section') {
              const v2Columns = (comp.columns || comp.fields || []).map(c => ({
                ...c,
                columnName: c.columnName || c.label || '',
                id: c.id || c.key || '',
                question: c.question || c.label || '',
              }));
              answer_list = hasItems(v2Columns)
                ? v2Columns
                : getLegacyAnswerList();
            } else if (hasMeaningfulOptions(comp.options)) {
              answer_list = comp.options;
            } else {
              answer_list = getLegacyAnswerList();
            }
          }

          break;
        }
      }

      page_answer[key] = answerDecoder(
        this.form.state.answer[key],
        answer_list
      );
    });
  };

  /**
   * Recursively unwraps answer data for display
   */
  unWrap_answer = (data, container, current_deepth) => {
    if (typeof data != 'string' && typeof data != 'number') {
      for (let key in data) {
        if (current_deepth == 0) {
          container.push(<ul>{key} </ul>);
        } else {
          let curr = container[container.length - 1];
          let tmp = React.Children.toArray(curr.props.children);
          tmp.push(<ul>{key}</ul>);
          container[container.length - 1] = React.cloneElement(curr, {
            children: tmp,
          });
        }
        this.unWrap_answer(data[key], container, current_deepth + 1);
      }
    } else {
      if (current_deepth == 0) {
        container.push(<ul>{data} </ul>);
      } else {
        let curr = container[container.length - 1];
        let tmp = React.Children.toArray(curr.props.children);
        tmp.push(
          <ul>
            <li>{data}</li>
          </ul>
        );
        container[container.length - 1] = React.cloneElement(curr, {
          children: tmp,
        });
      }
      this.form.state.summary = container;
      return container;
    }
  };

  /**
   * Extracts display name from form data
   */
  getDisplayName = (data) => {
    if (data) {
      if (data.project_name) {
        //we found the project name
        return data.project_name.answer[0];
      } else if (data.site_name) {
        return data.site_name.answer[0];
      } else if (data.Q3 && data.Q3.answer[0]) {
        //this is the last resort to handle the old forms
        return data.Q3.answer[0];
      }
    }
  };

  /**
   * Checks if data is contained in container using deep equality
   */
  isContain = (data, container) => {
    function hasObject(element, target) {
      return require('lodash').isEqual(element, target);
    }

    let i = undefined;

    container.forEach((n) => {
      let a = hasObject(n, data);
      if (a == true) {
        i = n;
      }

      if (Array.isArray(n)) {
        if (data == n[0]) {
          i = n;
        }
      }
    });
    return i;
  };

  /**
   * Generates URL preview link
   */
  urlPreviewLink(title) {
    return title + ' | Workflow86';
  }

  /**
   * Cookie utility function
   */
  getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  }

  /**
   * Sets state asynchronously
   */
  setStateAsync(state) {
    return new Promise((resolve) => {
      this.form.setState(state, resolve);
    });
  }
}

export default FormDataManager;
